import script from "./LibraryEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./LibraryEditor.vue?vue&type=script&setup=true&lang=js"

import "./LibraryEditor.vue?vue&type=style&index=0&id=a76d9e30&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76d9e30"]])

export default __exports__